import { Dispatch, SetStateAction, useState } from "react";
import { UseQueryResult, useQuery } from "react-query";
import { CustomerSessionData, Device, useQueryApiError } from "../types";
import { useUser } from "./useUser";
import { getDevicesByIdService } from "../services/deviceByIdService";

type UseDeviceByIdParams = {
  serviceProvider: string;
  ciamId: string;
  username: string;
  deviceId: string;
};

type GetDevicesByIdServiceResponseType = {
  registeredDeviceData: Device;
  customerSessionData: CustomerSessionData[];
};

type UseDeviceByIdHookType = {
  devicesByIdQuery: UseQueryResult<GetDevicesByIdServiceResponseType, useQueryApiError>;
  setFetched: Dispatch<SetStateAction<boolean>>;
};

export const useDeviceById = ({
  serviceProvider,
  ciamId,
  username,
  deviceId
}: UseDeviceByIdParams): UseDeviceByIdHookType => {
  const {
    user: { token }
  } = useUser();
  const [fetched, setFetched] = useState(false);

  const keyCache = `${serviceProvider}-${ciamId}-${username}-sessions-${deviceId}`;

  const devicesByIdQuery = useQuery<any, useQueryApiError>(
    [keyCache],
    async () => {
      const response = await getDevicesByIdService({ serviceProvider, token, ciamId, username, deviceId });
      setFetched(false);
      return response;
    },
    { enabled: fetched, cacheTime: 500 }
  );

  return {
    devicesByIdQuery,
    setFetched
  };
};
